// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".display-overflow {\n  overflow-y: auto;\n}\n.action {\n  margin-left: 4px;\n  padding: 2px 6px;\n  margin-bottom: 4px;\n}\n.action, .action[disabled]:active {\n    background-color: transparent !important;\n    border: none !important;\n}\n.action:focus, .action:active:focus {\n    outline: none;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n}\n", ""]);
// Exports
module.exports = exports;
